import React from 'react';
import { withLocalize } from 'react-localize-redux';
import QuickReportRow, { rowType } from './quickReportRow';
import { isNullOrUndefined } from '../../../store/storeFunctions';

import './quickReport.scss';

class QuickReportFinStatementsInfo extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        if (isNullOrUndefined(data.companyId))
            return null;
        if (isNullOrUndefined(data.deed))
            return null;

        const url = `https://or.justice.cz/ias/ui/rejstrik-$firma?ico=${data.companyId}`;

        return (
            <div className="columns">
                <div className="column is-12-desktop">
                    <table className="table table-report-section key-value">
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.LastDeedInsertionData" value={data.deed.insertionDataFormated} />
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.DocumentName" value={data.deed.documentName} />
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.Year" value={data.deed.year} />
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.Url" value={url} type={rowType.link}
                                label={this.props.translate("Report.Quick.FinStmtInfo.CollectionOfDocuments")} />
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.ProcessingDate" value={data.deed.lastTouchTimeStampFormated} />
                            <QuickReportRow translationKey="Report.Quick.FinStmtInfo.Status" value={data.deed.status} />
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withLocalize(QuickReportFinStatementsInfo);